import React, { useRef, useState } from 'react';
import Button from '#lib/components/button.jsx';
import { Icon } from '@iconify-icon/react';
import { Link } from 'react-router-dom';
import { getNRandomInt } from '#helpers/helpers.js';
import { cn } from '#lib/helpers/class.js';

const randomQA = [
    {
        question: '... create a new itinerary?',
        url: '/HowTo/#2-how-to-create-a-new-itinerary'
    },
    {
        question: '... import an itinerary?',
        url: '/HowTo/#3-how-to-import-an-itinerary'
    },
    {
        question: '... publish an itinerary?',
        url: '/HowTo/#4-how-to-publish-an-itinerary'
    },
    {
        question: '... generate places with AI?',
        url: '/HowTo/#7-how-to-create-new-places-using-ai'
    },
    {
        question: '... create a profile?',
        url: '/HowTo/#6-how-to-create-profiles'
    },
    {
        question: '... style an itinerary?',
        url: '/HowTo/#5-how-to-style-an-itinerary'
    }
];

export default function HowToList() {
    const randomIndexes = useRef(getNRandomInt(randomQA.length, 5)).current;
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div className="relative w-full md:w-1/3 md:h-full p-3 flex flex-col gap-2 justify-between md:shadow-lg md:rounded-xl">
            <h2 className="font-bold text-lg">{_t.home.howTo()}</h2>
            <div className="flex flex-col flex-grow gap-2">
                {randomIndexes.map((index) => (
                    <HowToQuestion
                        key={index}
                        index={index}
                        question={randomQA[index]?.question}
                        url={randomQA[index]?.url}
                        hoveredIndex={hoveredIndex}
                        handleHovered={() => setHoveredIndex(index)}
                        cancelHovered={() => setHoveredIndex(null)}
                    />
                ))}
            </div>
            <Link className="w-fit" to={DOCS_URL} target="_blank">
                <Button look="primary">
                    <React.Fragment>
                        <span>{_t.home.goToDocs()}</span>
                    </React.Fragment>
                    <Icon icon="line-md:arrow-small-right" width="1.4rem" height="1.4rem" className="ml-2 pt-1" />
                </Button>
            </Link>
        </div>
    );
}

function HowToQuestion({ index, question, url, hoveredIndex, handleHovered, cancelHovered }) {
    const isHovered = hoveredIndex === index;
    return (
        <Link to={DOCS_URL} target="_blank">
            <div
                className={cn(
                    'flex justify-between items-center rounded-lg py-[3px] px-2',
                    isHovered && 'bg-primary-50 text-primary-600'
                )}
                onMouseOver={handleHovered}
                onMouseOut={cancelHovered}
            >
                <span
                    className={cn(
                        'italic text-neutral-900 text-ellipsis truncate whitespace-nowrap',
                        isHovered && 'text-primary-600'
                    )}
                >
                    {question}
                </span>
                <Icon
                    icon="line-md:arrow-small-right"
                    width="1.4rem"
                    height="1.4rem"
                    className={cn(isHovered && 'text-primary-600')}
                />
            </div>
        </Link>
    );
}
